import { Text } from '@/components/atoms/text';
import { BlockComponentModel } from '@/components/cms/types/blok-component';

import { BlockHeaderContent } from '@/features/utils/BlockHeaderContent';
import { BlockWrapper } from '@/features/utils/BlockWrapper';
import { getText } from '@/lib/i18n/i18n.server';

import IconMoneyBack from '~/svg/IconMoneyBack.svg';

export interface FooterBannerStrapiProps {
  header: {
    title?: string;
    subtitle?: string;
  };
  isMoneyBackVisible?: boolean;
}

export default async function FooterBannerStrapi({
  block,
}: BlockComponentModel<FooterBannerStrapiProps>) {
  const { header, isMoneyBackVisible } = block;
  const texts = await getText();

  return (
    <BlockWrapper
      theme='dark'
      showDivider
      classNames={{
        divider:
          'px-5 lg:px-10 md:px-5 max-w-[1064px] lg:max-w-[1104px] mx-auto',
        dividerWrapper:
          'w-full bg-neutral-dark-N99 max-w-full md:max-w-full mx-auto',
      }}
    >
      <div data-tracker-section='footer-banner'>
        <BlockHeaderContent
          {...header}
          buttonPosition='top'
          classNames={{
            header: '!mb-4',
          }}
        >
          {isMoneyBackVisible && (
            <div className='text-neutral-N20 flex items-center justify-center gap-2'>
              <IconMoneyBack className='text-success-S99' />
              <Text variant='body-s'>
                {texts.pricing_cards.money_back.money_back_option}
              </Text>
            </div>
          )}
        </BlockHeaderContent>
      </div>
    </BlockWrapper>
  );
}
